


















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IRoomControl } from "@/@types/hotel/room";
import { ILocale } from "@/@types/locale";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { VueEditor } from "vue2-editor";

import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import BSwitch from "../../app/switchs/b-switch.vue";

@Component({
  mixins: [validationMixin],
  validations: {
    name: { required },
  },
  components: {
    BSwitch,
    VueEditor,
    onsubmit: SubmitResetButtonGroop,
  },
})
export default class RoomControlForm extends Vue {
  @Prop({ type: Object, default: null }) el!: IRoomControl;
  @Prop({ type: Boolean, default: false }) showcolor!: boolean;

  get languages(): Array<string> {
    return this.$store.getters.getLanguages;
  }

  locale = this.$store.getters.getLanguages[0];

  name = "";
  names: ILocale = {};
  show = true;
  color = "#F8D7DA";

  get item(): Partial<IRoomControl> {
    return {
      _id: this.el ? this.el._id : "",
      name: this.names,
      show: this.show,
    };
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }
    const data: Partial<IRoomControl> = this.item;
    if (this.showcolor) data.color = this.color;
    this.$emit("change", data, this.item._id);
  }

  onReset(): void {
    this.show = false;
    this.names = {};
    this.name = "";
    this.locale = this.languages[0];
  }

  @Watch("locale")
  update(): void {
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";
  }

  @Watch("name")
  changeName(): void {
    this.names[this.locale] = this.name;
  }

  @Watch("el")
  autoFillingForm(): void {
    if (!this.el) return;
    this.names = JSON.parse(JSON.stringify(this.el.name));
    this.show = this.el.show;
    if (this.showcolor) this.color = this.el.color;
    this.update();
  }

  mounted(): void {
    if (this.el) this.autoFillingForm();
  }
}
